import { Stack } from "@mui/system";
import { ReactNode } from "react";
import { useGetUserShareCampaignRoles } from "../../hooks";
import { ShareCampaignRoles } from "../../types/enums";
import { ReuseTooltip } from "../ui";
import {
  EditPenIcon,
  EyeOutlinedIcon,
  ShieldWithUserIcon,
  ThreePeopleIcon,
} from "../images";

const RoleWrapper = ({
  icon,
  tooltip,
}: {
  icon: ReactNode;
  tooltip: string;
}) => {
  return (
    <ReuseTooltip text={tooltip} hideChildren={false} maxWidth="200px">
      <Stack
        sx={{
          flexDirection: "row",
          width: "24px",
          height: "24px",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 1,
          backgroundColor: "#D3EAF6",
          borderRadius: "50%",
        }}
      >
        {icon}
      </Stack>
    </ReuseTooltip>
  );
};

export const RolesIconsBlock = ({
  userRoles,
  isShared,
}: {
  userRoles: ShareCampaignRoles[];
  isShared: boolean;
}) => {
  const { isOwner, isAdmin, isEditor, isOnlyViewer } =
    useGetUserShareCampaignRoles(userRoles);

  if (isOwner && !isShared) return null;

  return (
    <Stack direction="row" gap="8px">
      {isOwner && isShared && (
        <RoleWrapper
          icon={<ThreePeopleIcon />}
          tooltip={
            "You are the owner and have shared this campaign with others"
          }
        />
      )}

      {!isOwner && (
        <RoleWrapper
          icon={<ThreePeopleIcon />}
          tooltip={"You can see this campaign because it was shared with you."}
        />
      )}

      {isOnlyViewer && (
        <RoleWrapper
          icon={<EyeOutlinedIcon />}
          tooltip={"You can view campaign’s content but can’t make changes."}
        />
      )}

      {isEditor && (
        <RoleWrapper
          icon={<EditPenIcon />}
          tooltip={"You have permission to edit this campaign"}
        />
      )}

      {(isAdmin || isOwner) && (
        <RoleWrapper
          icon={<ShieldWithUserIcon />}
          tooltip={"You can also manage user access to this campaign."}
        />
      )}
    </Stack>
  );
};
